const PopupVideo = () => {
    const videoPopup = document.querySelector('.popup-video');
    const videoPopupBtn = document.querySelector('.js-video-popup');
    const video = document.getElementById('popupVideo');

    if (!videoPopup || !videoPopupBtn || !video) return;

    videoPopupBtn.addEventListener('click', () => {
        videoPopup.classList.add('-show');
        video.play();
    });

    const closeBtn = videoPopup.querySelector('button');
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            videoPopup.classList.remove('-show');
            video.pause()
        });
    }

    videoPopup.addEventListener('click', (e) => {
        const isClickInside = e.target.closest('.popup-video__container video');
        if (!isClickInside) {
            videoPopup.classList.remove('-show');
            video.pause();
        }
    });
}

PopupVideo();
